module.exports = __webpack_public_path__ + "static/digital-army-resource-tile-e382211244b96a17e42237e53b2edb91.jpeg";